<template>
  <ul class="categories">
    <li v-for="(item, index) in items" :key="index">
      <a
        href="javascript:void()"
        @click="select(index)"
        v-bind:class="{ active: selectedIndex === index }"
        >{{ item }}</a
      >
    </li>
  </ul>
</template>

<script>
export default {
  props: ["items", "value"],
  data() {
    return {
      selectedIndex: -1
    };
  },
  methods: {
    select(index) {
      this.selectedIndex = index;
      this.emitValue();
    },
    init() {
      if (this.value) {
        this.selectedIndex = this.items.find(i => i == this.value);
      }
    },
    emitValue() {
      if (this.selectedIndex !== -1) {
        this.$emit("input", this.valueToItem);
      }
    }
  },
  computed: {
    valueToItem() {
      return this.items[this.selectedIndex];
    }
  },
  mounted() {
    this.init();
  }
};
</script>
